/**
 * @generated SignedSource<<4d9eb52ca177d6fcc18ce7650e07c575>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type processDefinitionsQueryDeleteMutation$variables = {
  ids: ReadonlyArray<string>;
};
export type processDefinitionsQueryDeleteMutation$data = {
  readonly deleteProcessDefinitions: boolean | null | undefined;
};
export type processDefinitionsQueryDeleteMutation = {
  response: processDefinitionsQueryDeleteMutation$data;
  variables: processDefinitionsQueryDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteProcessDefinitions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionsQueryDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionsQueryDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5807550ef39fc7947cf7c21897fe04de",
    "id": null,
    "metadata": {},
    "name": "processDefinitionsQueryDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionsQueryDeleteMutation(\n  $ids: [ID!]!\n) {\n  deleteProcessDefinitions(ids: $ids)\n}\n"
  }
};
})();

(node as any).hash = "c572acc1f7a01246e9d5a97bb95d2543";

export default node;
